import DEFAULT_META_TAGS from '@/constants/meta'
import type { WebSite, WithContext } from 'schema-dts'

const FlightSchemaMarkup: WithContext<WebSite> = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.priceline.com/flights',
  name: 'Priceline',
  description: DEFAULT_META_TAGS.description.flights,
} as const

export default FlightSchemaMarkup
